import React from "react"

/**
 * Bulk action bar that appears when files are selected.
 * Shows Mark Placed, Out of Scope, and Delete buttons.
 *
 * @param {Object} props
 * @param {number} props.selectedCount - Number of selected files
 * @param {Function} props.onMarkPlaced - Callback for Mark Placed action
 * @param {Function} props.onMarkOutOfScope - Callback for Out of Scope action
 * @param {Function} props.onDelete - Callback for Delete action
 * @returns {React.ReactElement|null} The bulk action bar or null if nothing selected
 */
export function BulkActionBar({ selectedCount, onMarkPlaced, onMarkOutOfScope, onDelete }) {
  if (selectedCount === 0) return null

  return (
    <div className="bulk-action-bar">
      <button className="bulk-action-btn" type="button" disabled>
        Move to… ▾
      </button>
      <button className="bulk-action-btn" onClick={onMarkPlaced} type="button">
        Mark Placed
      </button>
      <button className="bulk-action-btn" onClick={onMarkOutOfScope} type="button">
        Out of Scope
      </button>
      <button className="bulk-action-btn delete" onClick={onDelete} type="button">
        Delete
      </button>
    </div>
  )
}
